module.exports = __webpack_public_path__ + "static/media/3DPPA28.3d945ddf.jpg";